import { SidebarMenuConfigRepository } from "../data/SidebarMenuConfigRepository";
import { IConfigRepository } from "../domain/repositories/IConfigRepository";
import { SidebarMenuUseCase } from "../domain/useCases/SidebarMenuUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class SidebarMenuInjection extends InjectionModule {
  private static readonly sidebarConfigRepositoryToken =
    Symbol("IConfigRepository");
  private static readonly sidebarMenuUseCaseToken =
    Symbol("SidebarMenuUseCase");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.sidebarConfigRepositoryToken,
      useClass: SidebarMenuConfigRepository,
    },
    {
      scope: "otherRepo",
      token: this.sidebarMenuUseCaseToken,
      useClass: SidebarMenuUseCase,
    },
  ];

  static getRepo(): IConfigRepository {
    return this.resolve(this.sidebarConfigRepositoryToken);
  }

  static getUseCase(): SidebarMenuUseCase {
    return this.resolve(this.sidebarMenuUseCaseToken);
  }
}
